import React, { forwardRef, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
    HOMEPAGE_NAV_ITEM_TAB,
    HOMEPAGE_DEFAULT_SLIDER_TAB,
} from '../../../../../../constants/homepage-types';
import HeaderNavItem from '../header-nav-item';
import './index.scss';

const HeaderExpendWindow = forwardRef(({
    children,
    navItemsList = [],
    isExpended = false,
    toggleExpend = () => {},
    selectedTab = HOMEPAGE_DEFAULT_SLIDER_TAB,
    onTabSelect = () => {},
    includeDefaultTabButton = false,
}, wrapperRef) => {
    const translations = useSelector((store) => store.config.Translations);

    const containerRef = useRef(null);

    const renderHiddenNavItem = (navItemData) => (
        <HeaderNavItem
            key={navItemData.key}
            data={navItemData}
            onSelect={toggleExpend}
            selectedTab={selectedTab}
            onTabSelect={onTabSelect}
            isVisible={false}
        />
    );

    const handleClickEvent = (event) => {
        if (containerRef?.current && !containerRef?.current?.contains(event.target)) {
            toggleExpend();
        }
    };

    useEffect(() => {
        if (isExpended) {
            document.addEventListener('click', handleClickEvent);
        }

        return () => document.removeEventListener('click', handleClickEvent);
    }, [isExpended]);

    return (
        <div className="header-expend-window-wrapper" ref={wrapperRef}>
            {children}

            {isExpended && (
                <div className="header-expend-window" ref={containerRef}>
                    {includeDefaultTabButton && renderHiddenNavItem({
                        key: 'default-tab-button',
                        index: HOMEPAGE_DEFAULT_SLIDER_TAB,
                        title: translations['homepage_category_initial_slider'],
                        type: HOMEPAGE_NAV_ITEM_TAB,
                    })}

                    {navItemsList.map(renderHiddenNavItem)}
                </div>
            )}
        </div>
    );
});

export default HeaderExpendWindow;
